<!-- Fecha só pelo X: clique fora ou Esc não tiram a pessoa do documento por engano. -->
<div class="pdf-viewer__overlay">
  <!-- Região que o usuário enxerga no portal (ver `ParentViewportService`). -->
  <div
    class="pdf-viewer__area"
    [style.top.px]="regiaoVisivel()?.top"
    [style.height.px]="regiaoVisivel()?.height"
  >
    <div
      class="pdf-viewer"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pdf-viewer-title"
      data-testid="pdf-viewer"
    >
      <header class="pdf-viewer__header">
        <span class="pdf-viewer__icone" aria-hidden="true">PDF</span>
        <h2 id="pdf-viewer-title" class="pdf-viewer__title" [title]="nome()">{{ nome() }}</h2>

        @if (urlSegura()) {
          <a
            class="pdf-viewer__nova-aba"
            target="_blank"
            rel="noopener"
            data-testid="pdf-viewer-nova-aba"
            [href]="url()"
          >
            Abrir em nova aba
          </a>        }

        <button
          #botaoFechar
          type="button"
          class="pdf-viewer__fechar"
          aria-label="Fechar visualização do PDF"
          data-testid="pdf-viewer-fechar"
          (click)="onFechar()"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      </header>

      <div class="pdf-viewer__corpo">
        @if (urlSegura(); as src) {
          <iframe
            class="pdf-viewer__documento"
            data-testid="pdf-viewer-documento"
            [src]="src"
            [title]="'Conteúdo de ' + nome()"
            [attr.aria-busy]="carregando()"
            (load)="onDocumentoCarregado($event)"
          ></iframe>

          @if (carregando()) {
            <!-- Sobre o documento, mas só dentro do corpo: o X continua ao alcance. -->
            <div class="pdf-viewer__carregando" role="status" data-testid="pdf-viewer-carregando">
              <app-spinner [show]="true" />
              <span class="pdf-viewer__carregando-texto">Carregando o PDF…</span>
            </div>
          }
        } @else {
          <p class="pdf-viewer__indisponivel" data-testid="pdf-viewer-indisponivel">
            Não foi possível abrir este arquivo aqui.
          </p>
        }
      </div>
    </div>
  </div>
</div>
